import React from "react";
import { Tabs } from "../../../../Components";
import { Tab } from "@headlessui/react";
import Profile from "./profile";
// import Preferences from "./preferences";
import Security from "./Security";
import { useUserConfig } from "../../../../Hooks/useUserConfig";

function Settings() {
	const { role } = useUserConfig();
	const isUser = role === "USER";

	let options = ["Security"];

	if (isUser) {
		options = ["My Profile", "Security"];
	}

	return (
		<>
			<div className="p-3 md:p-4">
				<div className="mb-4">
					<h2>Your Account</h2>
					<div className="mt-1 text-sm text-secondary">Manage your profile, security, and account access settings.</div>
				</div>
				<Tabs options={options} tabsClass="overflow-x-auto scrollbar-hidden whitespace-nowrap">
					{isUser && (
						<Tab.Panel>
							<Profile />
						</Tab.Panel>
					)}
					<Tab.Panel>
						<Security />
					</Tab.Panel>
				</Tabs>
			</div>
		</>
	);
}

export default Settings;
